import { createAction } from '@reduxjs/toolkit';
import { LexiconTagType } from 'src/services/src/service/lexicon/types';

export const lexiconTablePageActions = {
  navigateTo: createAction<{ navigateTo: string }>('LexiconTablePage/NavigateTo'),
  setCurrentTagType: createAction<{ tagType: LexiconTagType }>(
    'LexiconTablePage/SetCurrentTagType'
  ),
};
